import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/data/content";
import { MaskedLines, Reveal } from "./Reveal";

const pillars = [
  { title: "In-house manufacturing", desc: "OEM-grade excavator pins and bushes, machined and heat-treated under one roof." },
  { title: "Master distribution", desc: "Authorised master distributor of JIC Hydraulics for the territory of India." },
  { title: "Reliability, guaranteed", desc: "Earthmoving spare parts that set industry standards — we don't just meet them." },
];

export const Company = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="company" className="section section-cream company" data-testid="company-section">
      <Reveal>
        <p className="mono-label accent">01 / Company</p>
      </Reveal>
      <MaskedLines
        as="h2"
        className="section-title"
        lines={["Hardworking spares for", "hardworking earthmovers."]}
        data-testid="company-title"
      />
      <div className="company-grid">
        <Reveal delay={0.1} className="company-copy">
          <p className="lead" data-testid="company-lead">
            AP Enterprises is the one-stop powerhouse for excavator spare parts —
            an OEM-grade pins and bushes manufacturer with fully in-house production in
            Bengaluru, and India's aftermarket strength for genuine JIC hydraulic
            pumps and motors.
          </p>
          <div className="pillars">
            {pillars.map((p, i) => (
              <Reveal key={p.title} delay={0.15 + i * 0.1} y={28} className="pillar" data-testid={`company-pillar-${i + 1}`}>
                <span className="mono-label accent">0{i + 1}</span>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </Reveal>
            ))}
          </div>
        </Reveal>
        <div ref={ref} className="company-image clip-frame">
          <motion.img
            src={IMAGES.factoryFloor}
            alt="AP Enterprises factory floor — OEM-grade excavator pins and bushes manufacturer, Dobbaspet"
            style={{ y: imgY }}
            loading="lazy"
            data-testid="company-image"
          />
          <span className="mono-label image-caption">Inside our works — Dobbaspet.</span>
        </div>
      </div>
    </section>
  );
};
